
/* eslint-disable @typescript-eslint/no-shadow */
export namespace SurveyStatus {
  export enum SurveyStatus {
    DRAFT = "DRAFT",
    ACTIVE = "ACTIVE",
    CLOSED = "CLOSED",
  }

  export interface SurveyStatusDTO {
    case: string;
  }

  export const fromDTO = (dto: SurveyStatusDTO): SurveyStatus => {
    if (dto === undefined || dto === null) {
      throw new InvalidSurveyStatusError(
        `Invalid DTO ${dto} provided for SurveyStatus.SurveyStatus`
      );
    }
    switch (dto.case) {
      case "DRAFT":
        return SurveyStatus.DRAFT;
      case "ACTIVE":
        return SurveyStatus.ACTIVE;
      case "CLOSED":
        return SurveyStatus.CLOSED;
      default:
        throw new InvalidSurveyStatusError(
          `Case ${dto.case} is not valid case of SurveyStatus.SurveyStatus`
        );
    }
  };

  export const toDTO = (surveyStatus: SurveyStatus): SurveyStatusDTO => {
    const enumDTO = {
      case: SurveyStatus[surveyStatus],
    };
    return enumDTO;
  };
}

export class InvalidSurveyStatusError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusError";
  }
}
export class InvalidSurveyStatusDraftError extends InvalidSurveyStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusDraftError";
  }
}

export class InvalidSurveyStatusActiveError extends InvalidSurveyStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusActiveError";
  }
}

export class InvalidSurveyStatusClosedError extends InvalidSurveyStatusError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyStatusClosedError";
  }
}
